<template>
  <div>
    <portal-target name="dropdown" slim/>
    <div class="flex flex-col">
      <div class="min-h-screen flex flex-col" @click="hideDropdownMenus">
        <div class="md:flex bg-gray-600">
          <div class="flex flex-wrap sm:flex-nowrap justify-center sm:justify-between mx-auto w-full max-w-9xl px-2 md:px-6">
            <div class="w-auto md:min-w-64 md:w-auto flex-shrink-0 flex items-center justify-between md:justify-center overflow-hidden">
              <dropdown class="h-full md:min-w-64 md:w-auto py-2 px-3 bg-gray-500 hover:bg-gray-500 w-full" placement="bottom-end" ref="select-dealership">
                <div class="flex items-center justify-between cursor-pointer select-none group">
                  <div class="text-white mr-1 whitespace-nowrap truncate">
                    <span class="truncate">{{ $page.props.currentDealership.name }}</span>
                  </div>
                  <icon class="w-5 h-5 fill-current text-white" name="cheveron-down"/>
                </div>
                <div slot="dropdown" class="shadow-lg bg-gray-500 rounded-b w-64">
                  <div class="cursor-pointer block px-5 py-4 text-white hover:bg-gray-600" @click="changeDealership(dealership.slug)" v-for="dealership in $page.props.availableDealerships">
                    {{ dealership.name }}
                  </div>
                </div>
              </dropdown>
            </div>
            <div class="mx-4 w-full my-5 sm:my-0 py-1 flex justify-center sm:justify-start">
              <inertia-link :href="route('dashboard.show')" class="inline-block flex-shrinkß-0">
                <img src="/images/logo.png" class="h-10 mx-auto sm:mx-0" alt="Casa Auto">
              </inertia-link>
            </div>
            <dropdown class="flex-shrink-0 mr-4 sm:mr-10 py-4" placement="bottom-end" ref="conversations">
              <div class="flex cursor-pointer select-none group">
                <div class="text-white group-hover:text-coral-400 focus:text-coral-400 mr-1 whitespace-nowrap flex items-center relative">
                  <div>{{ __("Conversations") }}</div>
                  <div v-if="$page.props.auth.unreadConversations.length" class="bg-coral-400 text-white py-1 px-2 mr-1 rounded-full text-xs font-semibold absolute top-0 right-0 -mr-4 -mt-4">
                    {{ $page.props.auth.unreadConversations.length }}
                  </div>
                </div>
              </div>
              <div slot="dropdown" class="shadow-lg bg-gray-500 rounded-b w-64">
                <div class="flex flex-col justify-center text-white leading-normal">
                  <div @click="showConversation(conversation)" class="px-5 py-3 flex items-baseline cursor-pointer group text-gray-200" v-for="conversation in $page.props.auth.recentConversations" :key="'conversation-'+conversation.id">
                    <div class="h-2 w-2 mr-2 -ml-2 rounded-full flex-shrink-0" :class="{'bg-coral-400': conversation.last_message && !conversation.last_message.read}"></div>
                    <div v-if=" conversation.last_message">
                      <div class="text-xs font-bold mb-1 text-white group-hover:text-coral-400">{{ conversation.last_message.author.name }} <span class="font-light">- {{ conversation.last_message.created_at }}</span></div>
                      <div class="text-xs group-hover:text-coral-400">{{ conversation.last_message.body.substring(0, 50) }}...</div>
                    </div>
                  </div>
                </div>

                <button @click="indexConversations()" v-if="$page.props.auth.recentConversations.length" class="bg-gray-600 px-5 py-3 w-full block cursor-pointer text-white text-xs uppercase hover:text-coral-400 tracking-wide outline-none">
                  {{ __("See all conversations") }}
                </button>

                <div class="p-4 text-gray-300" v-if="!$page.props.auth.recentConversations.length">
                  {{ __("There are no conversations...") }}
                </div>
              </div>
            </dropdown>

            <dropdown class="flex-shrink-0 sm:mr-4" placement="bottom-end" ref="user-menu">
              <div class="flex items-center cursor-pointer select-none group">
                <div class="text-white group-hover:text-coral-400 focus:text-coral-400 mr-1 whitespace-nowrap flex items-center relative">
                  <div class="h-12 w-12 mr-2">
                    <img :src="$page.props.auth.user.avatar_url" :alt="$page.props.auth.user.name + ' profile image'" class="object-cover object-center h-full w-full"/>
                  </div>
                  <span>{{ $page.props.auth.user.name }}</span>
                  <span class="bg-coral-400 text-white py-1 px-2 absolute top-0 right-0 rounded-full text-xs font-semibold -mr-4" v-if="$page.props.auth.unreadNotificationsCount > 0">
                      {{ $page.props.auth.unreadNotificationsCount }}
                    </span>
                </div>
              </div>

              <div slot="dropdown" class="shadow-lg bg-gray-500 rounded-b w-64 text-sm">
                <div class="flex flex-col justify-center text-white leading-normal">
                  <div class="px-3 py-2 flex items-center cursor-pointer" v-for="notification in $page.props.auth.notifications" :key="'notification-'+notification.id" @click="showNotification(notification)">
                    <div class="bg-coral-400 h-2 w-2 mr-1 rounded-full flex-shrink-0" v-if="notification.read_at === null"></div>
                    <div class="hover:text-coral-400">{{ notification.data.title }}</div>
                  </div>
                </div>

                <button @click="indexNotifications()" v-if="$page.props.auth.notifications.length" class="bg-gray-600 px-5 py-3 w-full block cursor-pointer text-white text-xs uppercase hover:text-coral-400 tracking-wide outline-none">
                  {{ __("See all notifications") }}
                </button>

                <div class="flex flex-col justify-center text-white mx-5" v-if="$page.props.auth.user.permissions.create_consents">
                  <a target="_blank" class="text-white hover:text-coral-400 py-3 text-left" :href="route('consents.pending')" @click="closeUserMenu">
                    {{ __("Consent screen") }}
                  </a>
                </div>

                <div class="mx-5 flex justify-between items-center">
                  <inertia-link class="w-1/2 text-white hover:text-coral-400 py-4 text-left" :href="route('profile.edit')" @click="closeUserMenu()">
                    {{ __("Profile") }}
                  </inertia-link>
                  <form id="logout-form" :action="route('logout')" method="POST">
                    <input type="hidden" name="_token" :value="$page.props.csrfToken">
                    <button class="w-1/2 text-white hover:text-coral-400 py-4 text-right">
                      {{ __("Logout") }}
                    </button>
                  </form>
                </div>
              </div>
            </dropdown>
          </div>
        </div>
        <div v-if="$page.props.impersonation.active" class="bg-yellow-200 border-b border-yellow-400 text-yellow-900">
          <div class="mx-auto w-full max-w-9xl px-4 md:px-6 py-3 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div>
              {{ __('You are impersonating') }} {{ $page.props.auth.user.name }}
              <span v-if="$page.props.impersonation.impersonator">
                ({{ __('admin') }}: {{ $page.props.impersonation.impersonator.name }})
              </span>
            </div>
            <inertia-link :href="route('impersonations.stop')" method="post" as="button" class="px-3 py-2 bg-gray-700 text-white text-sm font-semibold rounded hover:bg-coral-400">
              {{ __('Stop impersonating') }}
            </inertia-link>
          </div>
        </div>

        <div class="flex flex-grow justify-center bg-gray-200">
          <div class="w-full max-w-9xl">
            <flash-messages></flash-messages>
            <slot/>
          </div>
        </div>

        <div class="flex justify-center bg-gray-600">
          <div class="w-full max-w-9xl p-6 text-white">
            Tester Group
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Dropdown from '@/Shared/Dropdown';
  import Icon from '@/Shared/Icon';
  import Logo from '@/Shared/Logo';
  import MainMenu from '@/Shared/MainMenu';
  import SelectInput from '@/Shared/SelectInput';
  import FlashMessages from '@/Shared/FlashMessages';

  export default {
    components: {
      Dropdown,
      Icon,
      Logo,
      SelectInput,
      FlashMessages,
      MainMenu,
    },
    props: {
      title: String
    },
    data() {
      return {
        showUserMenu: false,
      }
    },
    watch: {
      title(title) {
        this.updatePageTitle(title)
      },
    },
    mounted() {
      this.updatePageTitle(this.title);

      window.Echo.channel('App.Models.User.' + this.$page.props.auth.user.id)
        .listen('MessageCreatedEvent', (data) => {
          if (
            data.device_client_id === sessionStorage.getItem('deviceClientId')
            && data.author_id == this.$page.props.auth.user.id
            && data.author_type === 'App\\Models\\User'
          ) {
            return;
          }

          this.$inertia.reload({
            preserveState: true,
            preserveScroll: true
          })
        });

      window.Echo.private('App.Models.User.' + this.$page.props.auth.user.id)
        .notification((notification) => {
          if (notification.user_id == this.$page.props.auth.user.id) {
            return;
          }

          this.$inertia.reload({
            preserveState: true,
            preserveScroll: true
          })
        });
    },
    methods: {
      indexConversations() {
        this.$inertia.visit(this.route('conversations.index')).then(() => this.$refs['conversations'].close());
      },
      showNotification(notification) {
        this.$inertia.visit(this.route('notifications.show', {notification: notification.id})).then(() => this.closeUserMenu());
      },
      indexNotifications() {
        this.$inertia.visit(this.route('notifications.index')).then(() => this.closeUserMenu());
      },
      showConversation(conversation) {
        this.$inertia.visit(this.route('conversations.show', {conversation: conversation.id})).then(() => this.$refs['conversations'].close());
      },
      changeDealership(dealership) {
        this.$inertia.visit(this.route('dashboard.show', {dealership: dealership}));
        this.$refs['select-dealership'].close();
      },
      updatePageTitle(title) {
        document.title = title ? `${title} | ${this.$page.props.app.name}` : this.$page.props.app.name
      },
      closeUserMenu() {
        this.$refs['user-menu'].close();
      },
      hideDropdownMenus() {
        this.showUserMenu = false;
      }
    },
  }
</script>
